<template>
  <layout-block :width="width" margin="48px 16px">
    <layout-block-head
      icon="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/text-bubble-star.png"
      :title="reputation.title"
    />
    <ui-legend :label="reputation.legend" v-if="reputation.legend" />
    <layout-block-footer
      :trend="reputation.global_trend"
      v-if="reputation.global_trend === 'up' || reputation.global_trend === 'down'"
    />
    <!-- Reputation First Element -->
    <layout-block-section margin="32px 0" style="padding: 1px 0;">
      <div v-for="(r, idx) in reputation.data" :key="`reputation-data-${idx}`">
        <table style=" margin: 8px 16px ; width: calc(100% - 32px);table-layout: fixed; border-collapse: collapse;">
          <tr>
            <td align="left" ccolspan="1">
              <img
                :src="`https://gatoreviews-emails.s3.eu-west-3.amazonaws.com/generic/media-${r.source}.png`"
                width="40"
                height="40"
              />
            </td>
            <td style=" line-height: 42px; color: #06152F;font-size: 36px; font-weight: 800;" align="left">
              {{ Math.round(r.rating_value * 10) / 10 }}
            </td>
            <td colspan="2" align="right" style=" padding-right:16px;color: #06152F; font-size: 18px; font-weight:600;">
              {{ kFormatter(r.rating_count) }}
              <!-- <template v-if="r.new_count > 0">(+{{ r.new_count }})</template> -->
              <img
                src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/comment.png"
                width="16px"
                style="margin: auto 4px;"
              />
            </td>
            <td align="center" colspan="2">
              <ui-trend :trend="r.trend" />
            </td>
          </tr>
        </table>

        <layout-block-separator v-if="idx + 1 < reputation.data.length" />
      </div>
    </layout-block-section>
  </layout-block>
</template>

<script>
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockHead from '@/components/Layout/Block/Head.vue'
import LayoutBlockSection from '@/components/Layout/Block/Section.vue'
import LayoutBlockFooter from '@/components/Layout/Block/Footer.vue'
import LayoutBlockSeparator from '@/components/Layout/Block/Separator.vue'
import UiLegend from '@/components/UI/Legend.vue'
import UiTrend from '@/components/UI/Trend.vue'

export default {
  name: 'ReportReputation',
  components: {
    LayoutBlock,
    LayoutBlockHead,
    LayoutBlockSection,
    LayoutBlockFooter,
    UiLegend,
    UiTrend,
    LayoutBlockSeparator,
  },
  props: {
    width: {
      type: String,
      default: 'auto',
    },
    reputation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedReputation() {
      return this.reputation.data.filter((r, idx) => idx > 0)
    },
  },
  methods: {
    kFormatter(num) {
      return Math.abs(num) > 999 ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k' : num
    },
  },
}
</script>
